import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { useClient } from './ClientContext';
export function Hero() {
  const {
    clientName,
    companyName
  } = useClient();
  const firstName = clientName.split(' ')[0] || 'Andy';
  return <section className="pt-28 md:pt-32 pb-0" data-id="element-42">
      {/* Red hero intro - high impact */}
      <div className="bg-[#DC2626] px-4 md:px-6 py-16 md:py-32 border-y border-white/[0.06]" data-id="element-43">
        <div className="max-w-7xl mx-auto" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-45">
            <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-12" data-id="element-46">
              <div className="max-w-3xl" data-id="element-47">
                <h1 className="text-5xl sm:text-6xl md:text-8xl font-black leading-[0.9] tracking-tighter mb-8 md:mb-12 text-white uppercase" data-id="element-48">
                  Brand
                  <br data-id="element-49" />
                  Identity &
                  <br data-id="element-50" />
                  Positioning
                </h1>
                <div className="max-w-xl space-y-6 text-white/90 font-light text-base md:text-xl leading-relaxed" data-id="element-51">
                  <p data-id="element-52">
                    Hi {firstName}, thank you for the opportunity to share this
                    proposal. It outlines a focused approach to repositioning
                    NPP Neuro Group with a brand that clearly represents the
                    expertise and direction of the organisation today.
                  </p>
                </div>
              </div>

              <div className="pt-4 md:pt-0 md:text-right" data-id="element-53">
                <p className="text-xs md:text-sm font-mono text-white/60 mb-2" data-id="element-54">
                  PREPARED BY
                </p>
                <p className="text-xl md:text-2xl font-bold text-white uppercase tracking-tight" data-id="element-55">
                  Avy Pruthi
                </p>
                <p className="text-[11px] md:text-xs text-white/60 uppercase tracking-widest mt-1" data-id="element-56">
                  Founder & Director
                </p>

                {/* Signature squiggle */}
                <div className="mt-6 md:ml-auto w-32" data-id="element-57">
                  <svg width="120" height="50" viewBox="0 0 120 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-80" data-id="element-58">
                    <motion.path d="M5 38C8 28 12 15 18 12C24 9 22 30 26 28C30 26 32 10 38 14C44 18 40 35 46 32C52 29 56 8 62 12C68 16 64 34 70 30C76 26 82 10 86 16C90 22 88 38 94 34C100 30 104 18 108 22C112 26 115 35 115 35" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.7
                  }} transition={{
                    duration: 1.5,
                    delay: 0.8,
                    ease: 'easeInOut'
                  }} data-id="element-59" />
                  </svg>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Project Info */}
      <div className="px-4 md:px-6 border-b border-white/[0.06]" data-id="element-60">
        <motion.div className="max-w-7xl mx-auto py-8 md:py-10" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-61">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end" data-id="element-62">
            <div className="md:col-span-4" data-id="element-63">
              <div className="flex items-start gap-2 mb-2" data-id="element-64">
                <h2 className="text-lg md:text-xl font-bold text-white uppercase tracking-tight" data-id="element-65">
                  Brand Identity
                  <br data-id="element-66" />
                  <span className="text-zinc-500" data-id="element-67">& Positioning</span>
                </h2>
              </div>
            </div>

            <div className="md:col-span-8" data-id="element-68">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-69">
                <div data-id="element-70">
                  <span className="block text-zinc-600 text-[11px] uppercase tracking-widest mb-2" data-id="element-71">
                    Client
                  </span>
                  <span className="block font-mono text-sm md:text-base text-white" data-id="element-72">
                    {clientName}
                  </span>
                  <span className="block text-zinc-500 text-xs mt-1" data-id="element-73">
                    {companyName}
                  </span>
                </div>
                <div data-id="element-74">
                  <span className="block text-zinc-600 text-[11px] uppercase tracking-widest mb-2" data-id="element-75">
                    Agency
                  </span>
                  <span className="block font-mono text-sm md:text-base text-white" data-id="element-76">
                    AVY Consultancy
                  </span>
                </div>
                <div data-id="element-77">
                  <span className="block text-zinc-600 text-[11px] uppercase tracking-widest mb-2" data-id="element-78">
                    Date
                  </span>
                  <span className="block font-mono text-sm md:text-base text-white" data-id="element-79">
                    06.03.26
                  </span>
                </div>
                <div data-id="element-80">
                  <span className="block text-zinc-600 text-[11px] uppercase tracking-widest mb-2" data-id="element-81">
                    Valid until
                  </span>
                  <span className="block font-mono text-sm md:text-base text-white" data-id="element-82">
                    20.03.26
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Investment line */}
          <div className="mt-8 pt-8 border-t border-white/[0.06] flex items-center justify-between" data-id="element-83">
            <span className="text-zinc-500 text-xs md:text-sm uppercase tracking-widest font-bold" data-id="element-84">
              Total Investment
            </span>
            <span className="text-2xl md:text-3xl font-black text-white tracking-tight" data-id="element-85">
              £7,500{' '}
              <span className="text-base font-normal text-zinc-500" data-id="element-86">+ VAT</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}